import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import defaultValues from '../../constant/defaultValues';
import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from '../../components/InputField';
import SubHeader from '../../components/SubHeader';
import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from "../../actions/loaderAction";
import Emitter from "../../utils/Emitter";
import { isEmpty, size } from 'lodash';
import ToolipsCustom from '../../components/ToolipsCustom';
import { FilterMockInquiries } from '../../actions/inquiryAction';
import AllAdminInquiriesFilter from './AllAdminInquiriesFilter';
import MediumPopup from '../../components/MediumPopup';
import { ToastContainer } from 'react-toastify';
import LogisticInquiry from "../../components/inquiry/LogisticInquiry";
import SupplierInquiry from "../../components/inquiry/SupplierInquiry";
import RadioButtonField from "../../components/RadioButtonField";
import { buildPath } from '@/utils/common';
import { privateRoutePaths } from '@/routes/private.route.config';
import roles from '@/constant/roles.config';


function MockInquiries(props) {

    const { admin } = defaultValues;
    const { user, isSuperAdmin, isViewer, isPreKYCUser, isDemoUser, isEndUser, isAdmin } = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [mockInqList, setMockInqList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);
    const initialRef = useRef(true);
    const [columnName, setColumnName] = useState("id");
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);

    const [searchFilterObj, setFilterObj] = useState({
        filterBy: "",
        offset: admin.OFFSET,
        limit: admin.LIMIT,
        columnName: "id",
        sortDirection: admin.SORT_DIRECTION,
        filter_val: "",
        table_search: "",
        findWhom: "All",
        selected_country: null,
        startDate: null,
        endDate: null
    });

    // Inquiry  Variables
    const [inqModalShow, setInqModalShow] = useState(false);
    const [inqType, setInqType] = useState("SUPPLIER");


    const columns = [
        {
            name: 'Inq. ID',
            selector: row => <div className='text-wrap'>{row.inquiry_unique_id}</div>,
            width: "8%",
            columnName: 'inquiry_unique_id',
            sortable: true
        },
        {
            name: 'Company Name',
            selector: row => <div className='text-wrap'>{row.company_name}</div>,
            width: "22%",
            columnName: 'company_name',
            sortable: true
        },
        {
            name: 'Contact Person',
            selector: row => <div className='text-wrap text-capitalize'>{row.contact_person}</div>,
            width: "20%",
            columnName: 'contact_person',
            sortable: true
        },
        {
            name: 'Email',
            selector: row => <div className='text-wrap'>{row.email}</div>,
            width: "21%",
            columnName: 'email',
            sortable: true
        },
        {
            name: 'Country',
            selector: row => {
                if (!isEmpty(row.type)) {
                    if (row.type === 'Logistic_Partner') {
                        return <div className='text-wrap text-capitalize'>{!isEmpty(row.country_to) ? row.country_to : '-'}</div>
                    } else {
                        return <div className='text-wrap text-capitalize'>{!isEmpty(row.country) ? row.country : '-'}</div>
                    }
                } else {
                    return '-';
                }

            },
            width: "13%",
            columnName: "country",
            sortable: false
        },
        {
            name: 'Inq. Type',
            selector: row => {
                if (!isEmpty(row.type)) {
                    if (row.type === 'Logistic_Partner') {
                        return 'Logistic Partner';
                    } else {
                        return row.type;
                    }
                } else {
                    return '-';
                }
            },
            width: "10%",
            columnName: 'type',
            sortable: false
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div className="text-wrap panle-action">
                    {(isSuperAdmin && user.role_slug.slug === "SUP_ADM" || isAdmin) &&
                        // <Link to={"/mock-inquiry-view/" + row.id}>
                        //     <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 panle-icon" classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                        // </Link>

                        <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.MOCK_INQUIRY_VIEW, { id: row.id })}`}>
                            <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 panle-icon" classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                        </Link>
                    }
                </div>
            ),
            Width: '13%'
        }
    ];

    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    const handleSort = async (column, sortDirection) => {
        setColumnName(column.columnName);
        setSortDirection(sortDirection);
        filterMockInqData(
            offset,
            limit,
            current_page,
            column.columnName,
            sortDirection,
            searchTxt
        );
    };




    const onSearchTextBoxChanged = async (searchVal, sFilter) => {
        if (searchVal.length >= 3 || searchVal.length === 0) {
            setFilterObj(sFilter);
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName("id");
            setSortDirection(admin.SORT_DIRECTION);
            setCurrentPage(1);
            setTableKey((prev) => prev + 1);

            await filterMockInqData(
                admin.OFFSET,
                admin.LIMIT,
                1,
                "id",
                admin.SORT_DIRECTION,
                searchVal
            );
        }
    };

    // In your component
    const handleSearchChange = (e) => {
        const searchVal = e.target.value;
        setSearchTxt(searchVal);

        let sFilter = { ...searchFilterObj };
        sFilter.table_search = searchVal;

        onSearchTextBoxChanged(searchVal, sFilter);
    };

    const setMockInqFilters = (newState) => {
        newState.table_search = "";
        setSearchTxt("");
        setLimit(newState.limit);
        setOffset(newState.offset);

        setFilterObj(newState);

        setTableKey((prev) => prev + 1);
    }

    const filterApplyOnMockInq = (filterObj) => {
        filterMockInqData(admin.OFFSET, admin.LIMIT, current_page, "id", admin.SORT_DIRECTION, searchTxt);

    }

    const filterMockInqData = async (ofst = 0, lmt = 10, current_page = 1, columnName = "id", sortDirection = "DESC", searchval = "") => {
        props.showLoading();
        setNoData(false);
        let fObj = { ...searchFilterObj };
        if (fObj !== undefined && fObj !== 0 && fObj !== null && fObj !== "") {
            fObj.offset = ofst;
            fObj.limit = lmt;
            fObj.columnName = columnName;
            fObj.sortDirection = sortDirection;
            fObj.table_search = searchval;

            await props.FilterMockInq(fObj).then((response) => {
                if (response) {
                    if (response.status === true) {
                        if (size(response.data) === 0) {
                            setNoData(true);
                        }
                        setMockInqList(response.data);
                        settotalRows(response.metadata.total);
                    }
                }
            }).catch((err) => {
                console.log("Error ==== ", err);
            });

        }
        props.hideLoading();
    }

    const handleInquiryClick = () => {
        if (isViewer) {
            setInqType("LOG_PTR");
        } else {
            setInqType("SUPPLIER");
        }
        setInqModalShow(true);
    }

    const handleInquiryType = (e, type) => {
        setInqType(type);
    }


    useEffect(() => {
        async function fetchData() {
            await filterMockInqData(admin.OFFSET, admin.LIMIT, current_page, "id", admin.SORT_DIRECTION, searchTxt);

        }
        fetchData();
    }, []);



    useEffect(() => {
        Emitter.on("MOCK_FILTER_INQUIRIES", filterApplyOnMockInq);
        Emitter.on("SET_MOCK_FILTER_INQUIRIES", setMockInqFilters);
        return () => {
            Emitter.off("MOCK_FILTER_INQUIRIES", filterApplyOnMockInq);
        };
    });

    return (<>

        <div className='data-table-main logistic-table'>
            <div className="AcSimpleTable">

                <SubHeader layer1="Mock Inquiries" layer2="List" layer3=""
                    pageName="Mock Inquiries"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />

                <div className='filter-section'>
                    <AllAdminInquiriesFilter handleClick={handleInquiryClick} pageName="MOCK_INQ" />
                </div>
                <div className='card1'>

                    <div className='table-header-name'>
                        <h5 className='table-text py-3'>List</h5>
                        <div className='d-flex justify-content-between align-items-center py-3'>
                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25'
                                onChange={handleSearchChange}
                                value={searchTxt}
                                autoComplete="off"
                            />

                        </div>

                    </div>

                    <div className="table-wrapper">
                        <div className="table-container">
                            {mockInqList && (
                                <AcSimpleTable
                                    key={tableKey}
                                    data={mockInqList}
                                    title=""
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    getData={filterMockInqData}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    setColumnName={setColumnName}
                                    setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    // noDataComponent={<NoData />}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    current_page={current_page}
                                    setCurrentPage={setCurrentPage}
                                    noData={nodata}
                                    searchTxt={searchTxt}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MediumPopup title={`Add Inquiry`}
            mediummodalShow={inqModalShow}
            setMediumModalShow={setInqModalShow}>
            {(!isViewer || !isAdmin)  &&
                <div className="py-2">
                    <RadioButtonField
                        onChange={(e) =>
                            handleInquiryType(e, "SUPPLIER")
                        }
                        checked={inqType === "SUPPLIER"}
                    />
                    <label className="">Supplier</label>
                    <RadioButtonField
                        onChange={(e) =>
                            handleInquiryType(e, "LOG_PTR")
                        }
                        checked={inqType === "LOG_PTR"}
                    />
                    <label className="">Logistic Partner</label>
                </div>
            }

            {inqType === "LOG_PTR" && <LogisticInquiry mediummodalShow={inqModalShow} setMediumModalShow={setInqModalShow} pageView="pop_up" fromPage="MOCK_LIST" getData={filterMockInqData} inq_type={"REQ_MOCK_INQ"} />}


            {inqType === "SUPPLIER" && <SupplierInquiry mediummodalShow={inqModalShow}
                setMediumModalShow={setInqModalShow} pageView="pop_up" fromPage="MOCK_LIST" getData={filterMockInqData} inq_type={"REQ_MOCK_INQ"} />}

        </MediumPopup>
        {/* <ToastContainer /> */}

    </>)
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        FilterMockInq: (filterData) => dispatch(FilterMockInquiries(filterData))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MockInquiries);
